import DiagnosticsStore from "@/features/diagnostics/store/diagnostics-store.ts";

export default class NotFoundException extends Error {
    constructor(item: string) {
        const message = `${item} not found!`;

        super(message);

        DiagnosticsStore.collectEventLog("error", message);
    }
}
